const ListarProduto = () => import('../views/Listar')
const AdicionarProduto = () => import('../views/Adicionar')
const EditarProduto = () => import('../views/Editar')
const VisualizarProduto = () => import('../views/Visualizar')
const ImportarProduto = () => import('@/domains/produtos/gerenciar_produtos/views/Importar')
const AjustarValores = () => import('../views/AjustarValores')
const routes = [
    {
        name: 'listarProdutosEmissor',
        path: '/emissor/produtos',
        alias: ['/emissor/produtos/index'],
        component: ListarProduto
    },
    {
        name: 'adicionarProdutosEmissor',
        path: '/emissor/produtos/adicionar',
        component: AdicionarProduto,
        meta: {
            fullScreen: true
        }
    },
    {
        name: 'editarProdutosEmissor',
        path: '/emissor/produtos/editar/:id',
        component: EditarProduto,
        meta: {
            fullScreen: true
        }
    },
    {
        name: 'visualizarProdutosEmissor',
        path: '/emissor/produtos/visualizar/:id',
        component: VisualizarProduto,
    },
    {
        name: 'importarProdutosEmissor',
        path: '/emissor/produtos/importar_cadastros',
        component: ImportarProduto,
    },
    {
        name: 'ajustarValoresEmissor',
        path: '/emissor/produtos/ajustar_valores',
        component: AjustarValores
    },
]

export default routes
